// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUnderlineOutlinedSvg from "@fishx/icons-svg/es/asn/PUnderlineOutlined";
import FishxIcon from '../components/FishxIcon';

var PUnderlineOutlined = function PUnderlineOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUnderlineOutlinedSvg
  }));
};

PUnderlineOutlined.displayName = 'PUnderlineOutlined';
export default React.forwardRef(PUnderlineOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUnderlineOutlined.js
// module id = 3700
// module chunks = 0